/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import  { useState,useEffect, useCallback,useRef } from 'react'
import { useTranslation } from 'react-i18next';
import Header from "../../../components/uplift/Header";
import { LoaderPop, Modal } from "../../../common";
import { useLocation,useNavigate} from "react-router-dom";
import { APIEndpoint } from "../../../utils/axios";
import { formatDateByTimezone} from '../../../utils/commonFunctions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InventoryTable from "../../../components/uplift/InventoryTable";


export const ScannerUplift = () => {
    const { ready } = useTranslation();
    const headerRef = useRef();
    const initLoading = useRef(false);
    const [scannerData,setScannerData]=useState({});
    const [itemMasterAll,setItemMasterAll]=useState([]);
    const [scanHistoryArray,setScanHistoryArray]=useState([]);
    const [scannerItems,setScannerItems]=useState({});
    const [isLoading,setIsLoading]=useState(false);
    const [checkedItemsList,setCheckedItemsList] = useState([]);
    const [message,setMessage]=useState({text:"",isSaving:false,showHistory:false,defaultItems:false});
    const [filterItemsType, setFilterItemType] = useState({all:{checked:true,count:0},dutyPaid:{checked:false,count:0},dutyFree:{checked:false,count:0}});
    const location = useLocation();
    const navigate = useNavigate();
    const isDisabled = message.isSaving || isLoading || !(scannerData?.items?.length > 0);

  const updateCount = (index, delta) => {
    const newItems = [...scannerData.items];
    newItems[index].totalUplifted = Math.max(0, newItems[index].totalUplifted + delta);
    setScannerData((_)=>({..._,items:newItems}));
  };
      const showToast = useCallback(()=>{
        toast.dismiss();

        if (message.text) {
          toast.success(message.text, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: false,
            autoClose: 1800,
            style: {
              backgroundColor: '#52be52ff',
              color: '#fff',
              width:'30rem',
              borderRadius: '8px',
              fontSize: '1rem',
            }
          });
        } else if (message.error) {
          toast.error(message.error, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: false,
            autoClose: 2000,
            style: {
              backgroundColor: '#d9534f',
              color: '#fff',
              borderRadius: '8px',
              fontSize: '1rem',
              width:'30rem'
            }
          });
        } else {

        }
      },[message])

   useEffect(() => {
  if (!message.text && !message.error) return;
  showToast();
  const timer = setTimeout(() => {
    if (!message.text?.startsWith("Found Item") && !message.duration) {
      navigate(-1);
    }
    setMessage({ text: "" });
  }, 2000);

  return () => clearTimeout(timer);
}, [message.text, message.error, showToast]);

useEffect(() => {
    const items = scannerItems?.items || [];
  if (initLoading.current) {
    setScannerData(prev => ({
      ...prev,
      items: filterItemsType.dutyFree.checked
        ? items?.filter(item => item.dutyFree)
        :filterItemsType.dutyPaid.checked? items?.filter(item => !item.dutyFree):items,
    }));
  }
}, [filterItemsType]);

  useEffect(() => {
    let isMounted = true;

    async function fetchData() {
      if (location?.state?.scanId && !Object.keys(scannerData).length && itemMasterAll.length >0) {
        const { currentState } = location.state || {};
         let totalKey;

    if (currentState === "awaitingItemScanAndLoad") {
      totalKey = "scannedByWarehouseOfficer";
    } else if (currentState === "awaitingItemProcessingAndLoading") {
      totalKey = "confirmedByCateringOfficer";
    }else{
       totalKey = "reviewedByCateringManager";
    }
  
        try {
          const { scanId,warehouseName } = location.state;
          const rawData = await findByIdData(scanId);

          if (isMounted && totalKey) {
            const itemMap = new Map(itemMasterAll.map(item => [item.itemId, item]));
            const updatedItemsWithDutyFree = rawData.items.map(item => {
              const sourceItem = itemMap.get(item.itemId);
              return {
                ...item,
                dutyFree: sourceItem ? sourceItem.dutyFree : null 
              };
            });

            setScannerItems({...rawData,warehouseName,items:[...updatedItemsWithDutyFree.map(item=>({...item,totalUplifted:item[totalKey]?.total}))]});
          }
        } catch (err) {
          console.error('Failed to fetch scan data:', err);
        }
      }
      if(location?.state?.reconData && !Object.keys(scannerData).length && itemMasterAll.length>0){

        const {operationDate,flightDate,warehouseId,storeId,reconId}=location.state.reconData;
        const body = {
              operationDate: operationDate,
              flightDate: flightDate,
              warehouseId: warehouseId,
              storeId: storeId,
              reconId: reconId,
            };
        let enumData={
                warehouseId: Number(warehouseId),
                storeId: Number(storeId),
                operationDate:operationDate
            }
        try {
            const [resEdit,resEnum] = await Promise.all([
                APIEndpoint.post(`manualRecons/items`,body),
                APIEndpoint.post('stores/pricelist/items/enumerate',enumData),
              ]);
              if (resEdit && resEdit.success) {
            if(resEnum && resEnum.success){
               const itemMap = new Map(itemMasterAll.map(item => [item.itemId, item]));
            const updatedItemsWithDutyFree = resEnum.items.map(item => {
              const sourceItem = itemMap.get(item.itemId);
              return {
                ...item,
                dutyFree: sourceItem ? sourceItem.dutyFree : null 
              };
            });
                setScannerItems({...location.state.reconData,targetDate:location.state.reconData.operationDate,items: updatedItemsWithDutyFree.map(item => {
                const matchedItem = resEdit.items.find(it => it.itemId === item.itemId);
                if (matchedItem) {
                  return { ...matchedItem, dutyFree: item.dutyFree, totalUplifted: matchedItem?.actualOffload ?? 0 };
                }
                return item;
                })
                })
            }
          }
        } catch (error) {

        }
      }
    }

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [location,scannerData,itemMasterAll]);

useEffect(() => {
  const { scanId, currentState ,reconData} = location.state || {};
  const items = scannerItems?.items || [];
  if (scannerItems && scanId && items.length && !initLoading.current) {
    let totalKey;

    if (currentState === "awaitingItemScanAndLoad") {
      totalKey = "scannedByWarehouseOfficer";
    } else if (currentState === "awaitingItemProcessingAndLoading") {
      totalKey = "confirmedByCateringOfficer";
    }else{
       totalKey = "reviewedByCateringManager";
    }
    initLoading.current = true;
    if (totalKey) {
      setFilterItemType((prev) => {
  const summary = items.reduce(
    (acc, it) => {
      acc.all.count++;
      if (it.totalUplifted > 0) acc.all.scanned = true;

      if (it.dutyFree) {
        acc.dutyFree.count++;
        if (it.totalUplifted > 0) acc.dutyFree.scanned = true;
      } else {
        acc.dutyPaid.count++;
        if (it.totalUplifted > 0) acc.dutyPaid.scanned = true;
      }
      return acc;
    },
    {
      all: { count: 0, scanned: false },
      dutyFree: { count: 0, scanned: false },
      dutyPaid: { count: 0, scanned: false },
    }
  );

  return {
    ...prev,
    all: { ...prev.all, count: summary.all.count, scannedItemsExist: summary.all.scanned },
    dutyFree: { ...prev.dutyFree, count: summary.dutyFree.count, scannedItemsExist: summary.dutyFree.scanned },
    dutyPaid: { ...prev.dutyPaid, count: summary.dutyPaid.count, scannedItemsExist: summary.dutyPaid.scanned },
  };
});

      setScannerData(prev => ({
        ...prev,
        items: items.map(item => ({
          ...item,
          totalUplifted:item[totalKey]?.total
        })),
      }));
    }
  }
    if (scannerItems && reconData && items.length && !initLoading.current) {

      initLoading.current = true;
          setFilterItemType((prev) => {
  const summary = items.reduce(
    (acc, it) => {
      acc.all.count++;
      if (it.totalUplifted > 0) acc.all.scanned = true;

      if (it.dutyFree) {
        acc.dutyFree.count++;
        if (it.totalUplifted > 0) acc.dutyFree.scanned = true;
      } else {
        acc.dutyPaid.count++;
        if (it.totalUplifted > 0) acc.dutyPaid.scanned = true;
      }
      return acc;
    },
    {
      all: { count: 0, scanned: false },
      dutyFree: { count: 0, scanned: false },
      dutyPaid: { count: 0, scanned: false },
    }
  );

  return {
    ...prev,
    all: { ...prev.all, count: summary.all.count, scannedItemsExist: summary.all.scanned },
    dutyFree: { ...prev.dutyFree, count: summary.dutyFree.count, scannedItemsExist: summary.dutyFree.scanned },
    dutyPaid: { ...prev.dutyPaid, count: summary.dutyPaid.count, scannedItemsExist: summary.dutyPaid.scanned },
  };
});
      setScannerData(prev => ({
        ...prev,
        items
      }));
    
  }
}, [scannerItems, location.state]);

      const findByIdData = async (id) => {
        try {
          const res = await APIEndpoint.get(`uplifts/findById/${id}`);
          if (res?.success && res.result) {
            return res.result;
          } else {
            throw new Error('Invalid response');
          }
        } catch (err) {

          throw err;
        }
      };

      function resetScanCount(scanIds = []) {
        const idSet = new Set(scanIds);
        setScannerData((prevData) => ({
          ...prevData,
          items: prevData.items.map((item) =>idSet.has(item.itemId)? { ...item, totalUplifted: 0 }: item),
        }));
            setScannerItems((prevData) => ({
          ...prevData,
          items: prevData.items.map((item) =>idSet.has(item.itemId)? { ...item, totalUplifted: 0 }: item),
        }));
      setCheckedItemsList((prev) =>
        prev.filter((itemId) => !idSet.has(itemId))
      );
      }
const handleSubmitCounts=async(e)=>{
  const {items}=scannerItems;
e.stopPropagation();
if (!scannerData?.items?.length) return;
let data={};
items.forEach((item, index) => {
    const matchingItem = scannerData.items.find(obj => obj.itemId === item.itemId);
    if (matchingItem) {
        items[index] = { ...matchingItem };
    }
})
if(location.state?.reconData){

const {operationDate,flightDate,warehouseId,storeId,reconId} = location.state.reconData;
          data.items=items.map((item,index)=>({...item,index:index,actualOffload:item.totalUplifted}));
            if (!reconId) {
            data.operationDate = formatDateByTimezone(operationDate);
            data.storeId = parseInt(storeId, 10);
            data.flightDate = formatDateByTimezone(flightDate);
            data.warehouseId = parseInt(warehouseId, 10); 
            } else {
            data.manualReconId = reconId;
            data.warehouseId = parseInt(warehouseId, 10);
            }
            setMessage((_)=>({..._,isSaving:true}));

                   APIEndpoint.post('manualRecons/save', data)
                    .then( apiResp => {
                        setMessage({text:'Successfully updated counts' });
                    })
                    .catch( (error) => {
                      setMessage((_)=>({..._,isSaving:false}));
                      const apiData = JSON.parse(error.message).data;
                      if ( apiData.errors ) {
                      const errorMsg = apiData.errors.errors[0].message;
                      setMessage({error:errorMsg||"Failed to submit counts"});
                      }
                      else if (apiData.msg || apiData?.message) {
                      const saevErrorMessage  = apiData.msg || apiData?.message;
                      setMessage({error:saevErrorMessage||"Failed to submit counts"});
                      }
                      });
}else{
  const {id,warehouseId,storeId,dateModified}=scannerItems;
  const {currentState}=location.state;
  let inSheetData = [ ...items?.map((item,index)=>({
    bob:item.bob,
    corporate:item.corporate,
    estimatedQuantity:item.estimatedQuantity,
    index:index,
    itemCode:item.itemCode,
    itemName:item.itemName,
    [currentState==='awaitingItemProcessingAndLoading'?'confirmedByCateringOfficerValue':'scannedByWarehouseOfficerValue']:item.totalUplifted,
    unit:item.unit??null,
    webMeal:item.webMeal
  })) ];
setMessage((_)=>({..._,isSaving:true}));
  let data = {
          upliftId: id,
          warehouseId:warehouseId,
          storeId:storeId,
          flightDate:formatDateByTimezone(new Date(dateModified),true),
          items: inSheetData
      }

  APIEndpoint.post('uplifts/save', data)
  .then( apiResp => {
      setMessage({text:'Successfully updated counts' });
  })
  .catch( (error) => {
      setMessage((_)=>({..._,isSaving:false}));
      const apiData = JSON.parse(error.message).data;
      if ( apiData.errors ) {
          const errorMsg = apiData.errors.errors[0].message;
          setMessage({error:errorMsg||"Failed to submit counts"});
      }
      else if (apiData.msg || apiData?.message) {
          const saevErrorMessage  = apiData.msg || apiData?.message;
          setMessage({error:saevErrorMessage||"Failed to submit counts"});
      }
  });
}




}

function showScanHistory(){
  setMessage((_)=>({..._,showHistory:!_.showHistory}));
} 

function showUpliftItems(){
  if(scannerItems && location.state && location.state.scanId){
    setMessage((_)=>({..._,defaultItems:true}));
    setScannerData((_)=>({..._,items:scannerItems?.items.map(item=>({...item,totalUplifted:item.total}))}));
  }
}
function getStatusColor(fld){
  switch (fld) {
    case "Success":
      return "#5fe45fff"; 
    case "Scanning...":
      return "#70CEEA"; 
    case "Not Found":
      return "#f84c46ff"; 
    default:
      return "#6c757d";
  }
}

  const invTableProps={
  isLoading,
  checkedItemsList,
  setCheckedItemsList,
  showUpliftItems,
  showScanHistory,
  buttonList:message.defaultItems,
  scanHistoryArrayLength:scanHistoryArray?.length||0,
  items:scannerData?.items||[],
  resetScanCount,
  updateCount,
  isDisabled,
  handleSubmitCounts,
  stateScan:location?.state,
  filterItemsType,
  setFilterItemType
  }

  const headerProp={
  filters: scannerItems || {},
  itemMasterAll,
  inputFieldFocus: message,
  setItemMasterAll,
  setScanHistoryArray,
  headerRef,
  message,
  setMessage,
  checkedItemsList,
  filterItemsType,
  isLoading,
  setIsLoading,
  setScannerData,
  }
  
  return (
  <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
<> <Header headerProp={headerProp}/>
  {Object.keys(scannerItems).length>0?<> <div className="width100 flexCol" style={{ height:'calc(100vh - 215px)'}}>
  <div style={{ flex: 1,top:0,position:'sticky',overflowY:'auto',marginBottom:'2.5vh'}}>
    <InventoryTable invTableProps={invTableProps} />
  </div>
   
  <ToastContainer/>
  {(message.showHistory && scanHistoryArray?.length>0) ?
  <Modal
  title={'Scan History'}
  mainContentCenter={true}
  onClose={()=>setMessage((_)=>({..._,showHistory:false}))}
  onSubmit={()=>setMessage((_)=>({..._,showHistory:false}))}>
  <>
  <table>
      <thead>
    <tr>
      <th style={{ padding: '5px', whiteSpace: 'nowrap', textAlign: 'center' }}>Barcode No.</th>
      <th style={{ padding: '5px', whiteSpace: 'nowrap', textAlign: 'center' }}>Category</th>
      <th style={{ padding: '5px', whiteSpace: 'nowrap', textAlign: 'center' }}>Scan Time</th>
      <th style={{ padding: '5px', whiteSpace: 'nowrap', textAlign: 'center' }}>Status</th>
    </tr>
  </thead>
  <tbody>
  {scanHistoryArray.map((field, index) => (
  <tr key={index}>
  <td style={{padding:'8px',width:'30%',whiteSpace:'nowrap',textAlign: 'center',backgroundColor:`${index%2===0?'#0d2536':"none"}`}}>
  <div  className={`${field.heading ? 'h6' : 'header-footer-text'}`}>{field.scanId}</div>
  </td>
   <td style={{padding:'8px',width:'10%',whiteSpace:'nowrap',textAlign: 'center',backgroundColor:`${index%2===0?'#0d2536':"none"}`}}>
  <div  className={`${field.heading ? 'h6' : 'header-footer-text'}`}>{field.itemType}</div>
  </td>
  <td style={{padding:'8px',width:'40%',whiteSpace:'nowrap',textAlign: 'center',backgroundColor:`${index%2===0?'#0d2536':"none"}`}}>
  <div  className={`${field.heading ? 'h6' : 'header-footer-text'}`}>{field.scanTime}</div>
  </td>
  <td style={{padding:'8px',width:'20%',whiteSpace:'nowrap',textAlign: 'center',backgroundColor:`${index%2===0?'#0d2536':"none"}`}}>
  <div  className='header-footer-text' style={{ color: getStatusColor(field.status) }}>{field.status}</div>
  </td>
  </tr>
   ))}
  </tbody>
  </table>

 </>
 </Modal>:null
}
</div></>:<LoaderPop/>}</>

       {!ready && <div className='overlay_hide sub'></div>}
    </div>
  )
}
